import React from 'react'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import CircularProgress from '@mui/material/CircularProgress'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import createPlotlyComponent from 'react-plotly.js/factory'
import Plotly from 'plotly.js-basic-dist-min'

const Plot = createPlotlyComponent(Plotly)

const eurFormatter = new Intl.NumberFormat('fi-FI', { style: 'currency', currency: 'EUR' })

const COLOR = '#0b8043'
const COLOR_CURRENT = '#0b8043'
const COLOR_OTHER = '#a5d6b3'

const SalesSparklineCard = ({ title = 'Myynnin trendi (4 vk)', points, loading }) => {
  const safe = Array.isArray(points) ? points : []
  const xs = safe.map((p) => p.label)
  const ys = safe.map((p) => p.total)
  const markerColors = safe.map((_, i) => (i === safe.length - 1 ? COLOR_CURRENT : COLOR_OTHER))
  const markerSizes = safe.map((_, i) => (i === safe.length - 1 ? 9 : 6))
  const hoverText = safe.map((p) => `${p.label}: ${eurFormatter.format(p.total)}`)

  const data = [
    {
      x: xs,
      y: ys,
      type: 'scatter',
      mode: 'lines+markers',
      line: { color: COLOR, width: 2 },
      marker: { color: markerColors, size: markerSizes },
      hoverinfo: 'text',
      text: hoverText,
    },
  ]

  const layout = {
    autosize: true,
    height: 90,
    margin: { l: 8, r: 8, t: 4, b: 22 },
    showlegend: false,
    xaxis: { showgrid: false, zeroline: false, tickfont: { size: 10, color: '#6c757d' } },
    yaxis: { showgrid: false, zeroline: false, showticklabels: false, fixedrange: true },
    paper_bgcolor: 'transparent',
    plot_bgcolor: 'transparent',
    hoverlabel: { bgcolor: '#fff' },
  }

  const config = { displayModeBar: false, responsive: true }

  return (
    <Card sx={{ borderRadius: 2, height: '100%' }}>
      <CardContent sx={{ p: '12px 14px', '&:last-child': { pb: '12px' } }}>
        <Typography variant='caption' sx={{ color: 'text.secondary', textTransform: 'uppercase', letterSpacing: 0.3 }}>
          {title}
        </Typography>
        {loading ? (
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: 90 }}>
            <CircularProgress size={18} />
          </Box>
        ) : safe.length === 0 ? (
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: 90, color: 'text.secondary', fontSize: 12 }}>
            Ei dataa
          </Box>
        ) : (
          <Plot data={data} layout={layout} config={config} style={{ width: '100%', height: 90 }} useResizeHandler />
        )}
      </CardContent>
    </Card>
  )
}

export default SalesSparklineCard
